//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

/* global angular: false */

(function() {
  const curalate = angular.module('curalate');

  curalate.service('SyndicationService', [
    '$http',
    '$q',
    '$upload',
    'PromiseService',
    'RestBaseUrl',
    function(
            $http,
            $q,
            $upload,
            PromiseService,
            RestBaseUrl,
        ) {
      let creatorsPromise;
      let currentUserInfoPromise;
      let publishersPromise;

      this.imageFilter = {
        IMAGE_FILTER_ALL: 0,
        IMAGE_FILTER_PRODUCTIZED: 1,
        IMAGE_FILTER_UNPRODUCTIZED: 2,
        IMAGE_FILTER_LIKED: 3,
        IMAGE_FILTER_DISTRIBUTED: 4,
        IMAGE_FILTER_DOWNLOADED: 5,
        IMAGE_FILTER_SHARED: 6,
      };

      this.addImageFileAsync = function(image, partnerClientIds) {
        return PromiseService.processHttpResponse($upload.upload({
          url: `${RestBaseUrl}/syndication/images${partnerClientIds ? `?partnerClientIds=${partnerClientIds.toString()}` : ''}`,
          method: 'POST',
          file: image,
        }));
      };

      this.getImagesAsync = function(params) {
        return PromiseService.processHttpResponse($http.get(`${RestBaseUrl}/syndication/images`, { params }));
      };

      this.deleteImageAsync = function(imageId) {
        return PromiseService.processHttpResponse($http.delete(`${RestBaseUrl}/syndication/images/${imageId}`));
      };

      this.hideToggleAsync = function(imageId) {
        return PromiseService.processHttpResponse($http.post(`${RestBaseUrl}/syndication/images/${imageId}/toggle-hidden`));
      };

      this.shareToggleAsync = function(imageId) {
        return PromiseService.processHttpResponse($http.post(`${RestBaseUrl}/syndication/images/${imageId}/toggle-shared`));
      };

      this.getPublishersAsync = function() {
        publishersPromise = publishersPromise || PromiseService.processHttpResponse($http.get(`${RestBaseUrl}/syndication/publishers`));
        return publishersPromise;
      };

      this.getCreatorsAsync = function(force) {
        if (force || !creatorsPromise) {
          creatorsPromise = PromiseService.processHttpResponse($http.get(`${RestBaseUrl}/syndication/creators`));
        }
        return creatorsPromise;
      };

      this.getCurrentUserInfoAsync = function() {
                // Cache this response since its result will never change while the user is on the Share page.
        if (!currentUserInfoPromise) {
          currentUserInfoPromise = PromiseService.processHttpResponse($http.get(`${RestBaseUrl}/whoami`));
        }
        return currentUserInfoPromise;
      };

      this.saveUserImageActivity = function(imageId, actionString) {
        return PromiseService.processHttpResponse($http.post(`${RestBaseUrl}/syndication/images/${imageId}/save-action`, { action: actionString }));
      };

      this.searchProducts = function(searchText) {
        return PromiseService.processHttpResponse($http.get(`${RestBaseUrl}/syndication/products`, { params: { search: searchText } }), true);
      };

      this.updateImageProducts = function(imageId, products) {
        return PromiseService.processHttpResponse($http.post(`${RestBaseUrl}/syndication/images/${imageId}/products`, { products }));
      };

      this.getProductCatalogClients = function(imageId) {
        return PromiseService.processHttpResponse($http.get(`${RestBaseUrl}/syndication/images/${imageId}/product-catalog-clients`));
      };

      this.getPendingInvitationsAsync = function() {
        return PromiseService.processHttpResponse($http.get(`${RestBaseUrl}/syndication/invitations`));
      };

      this.getAcceptedInvitationsAsync = function() {
        return PromiseService.processHttpResponse($http.get(`${RestBaseUrl}/syndication/invitations/accepted`));
      };

      this.updateCreatorAliasAsync = function(creatorId, alias) {
        return PromiseService.processHttpResponse($http.post(`${RestBaseUrl}/syndication/creators/${creatorId}/alias`, { alias }));
      };

      this.createInvitationAsync = function(params) {
        return PromiseService.processHttpResponse($http.post(`${RestBaseUrl}/syndication/invitation`, params));
      };

      this.createEmailInvitationsAsync = function(params) {
        return PromiseService.processHttpResponse($http.post(`${RestBaseUrl}/syndication/invitation`, params));
      };

      this.getInvitationAsync = function(params) {
        return PromiseService.processHttpResponse($http.get(`${RestBaseUrl}/syndication/invitation`, { params }));
      };

      this.acceptInvitationAsync = function(params) {
        return PromiseService.processHttpResponse($http.put(`${RestBaseUrl}/syndication/invitation`, params));
      };

      this.expireInvitationAsync = function(params) {
        return PromiseService.processHttpResponse($http.delete(`${RestBaseUrl}/syndication/invitation/${params.invitationCode}`));
      };

      this.loginRequestAsync = function(params) {
        return PromiseService.processHttpResponse($http.post(`${RestBaseUrl}/syndication/login`, params));
      };

      this.getClientsAsync = function() {
        return PromiseService.processHttpResponse($http.get(`${RestBaseUrl}/clients`));
      };

      this.likeToggle = function(id) {
        return PromiseService.processHttpResponse($http.post(`${RestBaseUrl}/syndication/images/${id}/toggle-liked`));
      };

      this.updateEmailPreferencesAsync = function(params) {
        return PromiseService.processHttpResponse($http.put(`${RestBaseUrl}/syndication/settings/email-preferences`, params));
      };

      this.getEmailPreferencesAsync = function() {
        return PromiseService.processHttpResponse($http.get(`${RestBaseUrl}/syndication/settings/email-preferences`));
      };

      this.getMetricsAsync = function(params) {
        return PromiseService.processHttpResponse($http.get(`${RestBaseUrl}/syndication/metrics`, { params }));
      };
    },
  ]);
})();
